export default __webpack_public_path__ + "static/media/gallery_23.32d5d38e.jpg";